// Udesk 在线客服

import store from '@/store'
function add(x, y) {
        return ((x & 0x7FFFFFFF) + (y & 0x7FFFFFFF)) ^ (x & 0x80000000) ^ (y & 0x80000000);
}

function SHA1hex(num) {
        var sHEXChars = "0123456789abcdef";
        var str = "";
        for (var j = 7; j >= 0; j--)
                str += sHEXChars.charAt((num >> (j * 4)) & 0x0F);
        return str;
}

function AlignSHA1(sIn) {
        var nblk = ((sIn.length + 8) >> 6) + 1,
                blks = new Array(nblk * 16);
        for (var i = 0; i < nblk * 16; i++) blks[i] = 0;
        for (i = 0; i < sIn.length; i++)
                blks[i >> 2] |= sIn.charCodeAt(i) << (24 - (i & 3) * 8);
        blks[i >> 2] |= 0x80 << (24 - (i & 3) * 8);
        blks[nblk * 16 - 1] = sIn.length * 8;
        return blks;
}

function rol(num, cnt) {
        return (num << cnt) | (num >>> (32 - cnt));
}

function ft(t, b, c, d) {
        if (t < 20) return (b & c) | ((~b) & d);
        if (t < 40) return b ^ c ^ d;
        if (t < 60) return (b & c) | (b & d) | (c & d);
        return b ^ c ^ d;
}

function kt(t) {
        return (t < 20) ? 1518500249 : (t < 40) ? 1859775393 :
                (t < 60) ? -1894007588 : -899497514;
}
const SHA1 = function (sIn) {
    var x = AlignSHA1(sIn);
    var w = new Array(80);
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    var e = -1009589776;
    var t = ''
    var SHA1Value = ''

    for (var i = 0; i < x.length; i += 16) {
            var olda = a;
            var oldb = b;
            var oldc = c;
            var oldd = d;
            var olde = e;
            for (var j = 0; j < 80; j++) {
                    if (j < 16) w[j] = x[i + j];
                    else w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
                    t = add(add(rol(a, 5), ft(j, b, c, d)), add(add(e, w[j]), kt(j)));
                    e = d;
                    d = c;
                    c = rol(b, 30);
                    b = a;
                    a = t;
            }
            a = add(a, olda);
            b = add(b, oldb);
            c = add(c, oldc);
            d = add(d, oldd);
            e = add(e, olde);
    }
    SHA1Value = SHA1hex(a) + SHA1hex(b) + SHA1hex(c) + SHA1hex(d) + SHA1hex(e);
    return SHA1Value.toUpperCase();
};

export const getUrlKey = (name) => {
  if (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
  } else {
    return decodeURIComponent((new RegExp('[?|&]([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
  }
 
}

const getUdeskUrl = (uid, userName, eligibilityLevel) => {
  var baseUrl = process.env.NODE_ENV === 'production' ? 'https://aspiredigital.cn' : 'https://stg.aspiredigital.cn'
  return baseUrl + '/easemob/?configId=d3c2f3cf-cf96-4091-b677-17684f1e4fdf&userName=' + userName + '&companyName=MasterCard-运动健康&openId=' + uid +'&description=MasterCard-运动健康(' + eligibilityLevel +')有效持卡人&level=' + eligibilityLevel
}


/**
 * 存储localStorage
 */
export const setLocalStorage = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getLocalStorage = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeLocalStorage = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

export const linkToUdesk = () => {
  var userInfo = JSON.parse(getLocalStorage(store.state.userInfo))
  let { nickname, weixinOpenid, userLevel} = userInfo
  return getUdeskUrl(weixinOpenid,nickname,userLevel)
}

export const getStyle = (element, attr, NumberMode = 'int') => {
  let target
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop
  } else if (element.currentStyle) {
    target = element.currentStyle[attr]
  } else {
    target = document.defaultView.getComputedStyle(element, null)[attr]
  }
  // 在获取 opactiy 时需要获取小数 parseFloat
  return NumberMode === 'float' ? parseFloat(target) : parseInt(target)
}
/**
 * 页面到达底部，加载更多
 */
export const loadMore = (element, callback, distance = 10) => {
  let windowHeight = window.screen.height
  let height
  let setTop
  let paddingBottom
  let marginBottom
  let requestFram
  let oldScrollTop

  document.body.addEventListener('scroll', () => {
  	// height = element.offsetHeight
   //  setTop = element.offsetTop
   //  paddingBottom = getStyle(element, 'paddingBottom')
   //  marginBottom = getStyle(element, 'marginBottom')
   //  loadMore()
  }, false)
  // 运动开始时获取元素 高度 和 offseTop, pading, margin
  element.addEventListener('touchstart', () => {
    height = element.offsetHeight
    setTop = element.offsetTop
    paddingBottom = getStyle(element, 'paddingBottom')
    marginBottom = getStyle(element, 'marginBottom')
  }, {
    passive: true
  })

  // 运动过程中保持监听 scrollTop 的值判断是否到达底部
  element.addEventListener('touchmove', () => {
    // loadMore()
  }, {
    passive: true
  })

  // 运动结束时判断是否有惯性运动，惯性运动结束判断是非到达底部
  element.addEventListener('touchend', () => {
    oldScrollTop = document.documentElement.scrollTop
    loadMore()
    // moveEnd()
  }, {
    passive: true
  })
  const moveEnd = () => {
    requestFram = requestAnimationFrame(() => {
      if (document.documentElement.scrollTop !== oldScrollTop) {
        oldScrollTop = document.documentElement.scrollTop
        loadMore()
        moveEnd()
      } else {
        cancelAnimationFrame(requestFram)
        // 为了防止鼠标抬起时已经渲染好数据从而导致重获取数据，应该重新获取dom高度
        height = element.offsetHeight
        loadMore()
      }
    })
  }

  const loadMore = () => {
  	console.log(document.documentElement.scrollTop, windowHeight, height, setTop)
    if (document.documentElement.scrollTop + windowHeight >= height + setTop + paddingBottom + marginBottom - distance) {
      callback()
    }
  }
}

// 防抖
export const _debounce = (fn, delay) => {

    var delay = delay || 200;
    var timer;
    return function () {
        var th = this;
        var args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            timer = null;
            fn.apply(th, args);
        }, delay);
    };
}
// 节流
export const _throttle = (fn, interval) => {
    var last;
    var timer;
    var interval = interval || 200;
    return function () {
        var th = this;
        var args = arguments;
        var now = +new Date();
        if (last && now - last < interval) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                last = now;
                fn.apply(th, args);
            }, interval);
        } else {
            last = now;
            fn.apply(th, args);
        }
    }
}

//_debounce(function(_type, index, item) {
        // do something ...
    //}, 200)


// WEBPACK FOOTER //
// ./src/utils/index.js